import ShowInscriptionModalView from "./showInscriptionModal.html";
import EditInscriptionModalView from "./editInscriptionModal.html";
import CapacityDetailModalView from "./capacityDetailModal.html";
import NewInscriptionModalView from "./newInscriptionModal.html";
import AssignTagModalView from "./assignTagModal.html";
import _ from 'lodash';
import moment from 'moment-timezone';


angular.module("inscriptions_forms")

    .controller("InscriptionsFormsShowInscriptionsCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', 'clipboard', '$location', 'uiGridExporterService', '$stateParams', '$state', 'datasetsService', 'generateDocumentService', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, clipboard, $location, uiGridExporterService, $stateParams, $state, datasetsService, generateDocumentService, logService) {
        
        // Comprobamos si tiene permiso escritura
        $scope.myDefs = [];
        $scope.showActionsButtons = true;
        
        $scope.allowWrite = LoginService.permissionExist("INSCRIPTIONS_FORMS_WRITE");
        $scope.duplicate_string = $filter('translate')('inscriptions_forms.duplicate_string').toUpperCase();

        // Info evento no podemos utilizar la injection al controlador porque esta en guests.list como un ng-include.
        if ($state.current.name == "events.edit.inscriptions_forms.show_inscriptions") {
             Restangular.one('Events', $stateParams.id).get().then(function (results) {
                 $rootScope.title = results.name + " - " + $filter('translate')('inscriptions_forms.title');
                 $rootScope.breadcrumb = [
                     { title: $filter('translate')('events.title'), url: "events.list" },
                     { title: results.name , url: "events.edit({ id: " + results.id + " })" },
                     { title: $filter('translate')('inscriptions_forms.title'), url: "events.edit.inscriptions_forms({ event: " + $stateParams.id + " })" },
                 ];
             });
        }
        
        /*
            $rootScope.title = $filter('translate')('inscriptions_forms.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('inscriptions_forms.title'), url: "events.edit.inscriptions_forms({ event: " + $stateParams.id + " })" },
            ];
        */
        
        $scope.event = $stateParams.id;
        if (angular.isDefined($stateParams.inscription_form_id)) {
            Restangular.one('InscriptionsForms', $stateParams.inscription_form_id).get().then(function (results) {
                $scope.inscription_form = results
                if ($scope.inscription_form.is_approval_form) {
                    $scope.showActionsButtons = false;
                } else {
                    $scope.showActionsButtons = true;
                }
            });

        // Obtenemos los contadores de pendientes, aprobados y rechazados
            Restangular.all("InscriptionsForms").customGET("CustomGetContInscriptions", { id: $stateParams.inscription_form_id }).then(function (results) {
                $scope.accepted = results.inscriptions_approved_cont;
                $scope.rejected = results.inscriptions_rejected_cont;
                $scope.pending = results.inscriptions_pending_cont;
            });

            $scope.myDefs.push({
                    name: 'date',
                    displayName: $filter('translate')('general.date'),
                    width: 200,
                    exporterSuppressExport: true,
                    enableSorting: false,
                    enableHiding: false,
                    enableFiltering: false,
                    enableColumnMenu: false,
                    type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                          customFormatFn: function (value) {
                              if (value != null) {
                                  var fecha = new Date(value);
                                  return $filter('date')(fecha, 'dd/MM/yyyy HH:mm');
                              }
                              return "";
                    },
            });

            Restangular.all('InscriptionsFormsfields').getList({ inscription_form_id: $stateParams.inscription_form_id }).then(function (result) {
                
                var list_fields = _.filter(result, function (field) { return field.show_in_list; });
                
                for (let i = 0; i < list_fields.length; i++) {
//                    logService.debug(result[i].type_field_id, );
//                    if (result[i].type_field_id!=6) {
                        $scope.myDefs.push({
                            field: "_" + list_fields[i].id,
                            displayName: list_fields[i].name,
                            visible: i > 6 ? false : true,
                            name: "_" + list_fields[i].id
                        });
//                    }
                }

                 $scope.myDefs.push({
                    name: 'state',
                    displayName: $filter('translate')('inscriptions_forms.state'),
                    width: 150,
                    exporterSuppressExport: true,
                    enableSorting: false,
                    enableHiding: false,
                    enableFiltering: false,
                    enableColumnMenu: false,
                    cellTemplate: '<div class="ui-grid-cell-contents" ng-if=" !row.entity.duplicate && row.entity.state == null"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-warning">{{"inscriptions_forms.pending" | translate}}</label></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="!row.entity.duplicate && row.entity.state == 1"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-primary">{{"inscriptions_forms.approved" | translate}}</label></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="!row.entity.duplicate && row.entity.state == 0"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-danger">{{"inscriptions_forms.rejected" | translate}}</label></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.duplicate"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-info">{{grid.appScope.duplicate_string}}</label></div>' +
                        '</div>'
                });


                $scope.myDefs.push({
                    name: ' ',
                    width: 370,
                    exporterSuppressExport: true,
                    enableSorting: false,
                    enableHiding: false,
                    enableFiltering: false,
                    enableColumnMenu: false,
                    cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('inscriptions_forms.modify_tag'), action: 'ng-if="row.entity.state == 1 && row.entity.person_id != null && row.entity.event_guest.identify_id != null" ng-click="grid.appScope.associate_tag(row.entity);"', cssIconClass: "fa fa-wifi" },
                        { title: $filter('translate')('inscriptions_forms.assign_tag'), action: 'ng-if="row.entity.state == 1 && row.entity.person_id != null && row.entity.event_guest.identify_id == null" ng-click="grid.appScope.associate_tag(row.entity);"', cssIconClass: "fa fa-wifi" },
                        { title: $filter('translate')('inscriptions_forms.show_inscription'), action: 'ng-click="grid.appScope.show_inscription(row.entity);"', cssIconClass: "fa fa-file" },
                        { title: $filter('translate')('inscriptions_forms.edit_inscription'), action: 'ng-click="grid.appScope.edit_inscription(row.entity);"', cssIconClass: "fa fa-edit" },

                    ], { cssClass: "pull-right" })
                });

            });

            $scope.gridOptionsInscriptionsForms = {
                pdfTitle: $filter('translate')('inscriptions_forms.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: true,
                paginationPageSizes: [500, 750, 1000],
                paginationPageSize: 500,
                enableSorting: false,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: $scope.myDefs,
                getData: function (options) {
                    var deferred = $q.defer();
                    options.inscription_form_id = $stateParams.inscription_form_id;
                    options.event_id = $scope.event;
                    options.filters = [];
                    $scope.options = options;

                    /*
                        options._sortBy = "state";
                        options._sortDirection = "asc";
                    */

                    Restangular.all("Inscriptions").getList(options).then(function (inscriptions_fields) {
                        var data = inscriptions_fields;
                        $scope.inscriptions = inscriptions_fields;
                        data.totalRows = inscriptions_fields.totalRows;
                        $scope.totalRows = inscriptions_fields.totalRows;

                        /*
                        
                        $scope.filters = [];
                        
                        //Recogemos filtros

                        angular.forEach(inscriptions_fields[0].FK_inscriptions_fields_inscriptions, function (inscription_field) {
                            if (inscription_field.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_types_fields.filter) {
    
                                $scope.filters.push(inscription_field.FK_inscriptions_fields_inscriptions_forms_fields);
                            }
                        });

                        */

                        angular.forEach(inscriptions_fields, function (inscription_field) {



                            angular.forEach(inscription_field.FK_inscriptions_fields_inscriptions, function (item) {
                                if (item.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_types_fields.has_options) {
                                    for (let i = 0; i < item.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_options_inscriptions_forms_fields.length; i++) {
                                        if (item.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_options_inscriptions_forms_fields[i].id == item.value) {
                                            inscription_field["_" + item.FK_inscriptions_fields_inscriptions_forms_fields.id] = item.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_options_inscriptions_forms_fields[i].name;
                                        }
                                    }
                                } else {
                                    // logService.debug(item.FK_inscriptions_fields_inscriptions_forms_fields.name + " " + item.value);
                                    inscription_field["_" + item.FK_inscriptions_fields_inscriptions_forms_fields.id] = item.value;
                                }
                            });
                        });

                        $scope.total_inscriptions = $scope.accepted + $scope.pending + $scope.rejected;

                        data = inscriptions_fields;
                        deferred.resolve(data);


                    });

                    return deferred.promise;
                }

            };

            $scope.updateCapacity = function (id) {
                if (!angular.isUndefined($scope.inscription_form.id)) {
                    Restangular.all("InscriptionsForms").customGET("CustomSaveInscriptionCapacity", { id: $stateParams.inscription_form_id, capacity: $scope.inscription_form.capacity });

                    /*$scope.inscription_form.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('inscriptions_forms.capacity_updated'));                        
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });*/
                }
            }

            $scope.show_inscription = function (inscription) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: ShowInscriptionModalView,
                    controller: "ShowInscriptionModalCtrl",
                    size: 'lg',
                    resolve: {
                        inscription: function () {
                            return inscription
                        },
                        inscription_form_id: function () {
                            return $stateParams.inscription_form_id
                        }
                    }
                });

                $modalInstance.result.then(function (data) {
                    $scope.inscription = data.inscription;

                    var params = {
                        state: $scope.inscription.state,
                        inscriptionIds: $scope.inscription.id
                    }

                    if ($scope.inscription.is_deleted) {
                        $scope.gridOptionsInscriptionsForms.loadData(false);
                    } else {
                        if (params.state != null) {
                            Restangular.all("inscriptions").customPOST({}, "change_states", params).then(function (results) {
                                if (results) {
                                    if (params.state) {
                                        toastr.success($filter('translate')('inscriptions_forms.inscription_approved'));
                                    } else {
                                        toastr.error($filter('translate')('inscriptions_forms.inscription_rejected'));
                                    }
                                    $scope.gridOptionsInscriptionsForms.gridApi.core.raise.itemChanged($scope)
                                }
                                //Obtenemos los contadores de pendientes, aprobados y rechazados
                                Restangular.all("InscriptionsForms").customGET("CustomGetContInscriptions", { id: $stateParams.inscription_form_id }).then(function (results) {
                                    $scope.accepted = results.inscriptions_approved_cont;
                                    $scope.rejected = results.inscriptions_rejected_cont;
                                    $scope.pending = results.inscriptions_pending_cont;

                                });
                            });
                        } else {
                            $scope.inscription.put().then(function (result) {
                                $scope.gridOptionsInscriptionsForms.loadData(false);
                            })

                        }
                    }

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });
            }

            // TODO 
            $scope.edit_inscription = function (inscription) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: EditInscriptionModalView,
                    controller: "EditInscriptionModalCtrl",
                    size: 'lg',
                    resolve: {
                        inscription: function () {
                            return inscription
                        },
                        inscription_form_id: function () {
                            return $stateParams.inscription_form_id
                        }
                    }
                });

                $modalInstance.result.then(function (data) {
                    $scope.inscription = data.inscription;

                    var params = {
                        state: $scope.inscription.state,
                        inscriptionIds: $scope.inscription.id
                    }

                    if ($scope.inscription.is_deleted) {
                        $scope.gridOptionsInscriptionsForms.loadData(false);
                    } else {
                        if (params.state != null) {
                            Restangular.all("inscriptions").customPOST({}, "change_states", params).then(function (results) {
                                if (results) {
                                    if (params.state) {
                                        toastr.success($filter('translate')('inscriptions_forms.inscription_approved'));
                                    } else {
                                        toastr.error($filter('translate')('inscriptions_forms.inscription_rejected'));
                                    }
                                    $scope.gridOptionsInscriptionsForms.gridApi.core.raise.itemChanged($scope)
                                }
                                //Obtenemos los contadores de pendientes, aprobados y rechazados
                                Restangular.all("InscriptionsForms").customGET("CustomGetContInscriptions", { id: $stateParams.inscription_form_id }).then(function (results) {
                                    $scope.accepted = results.inscriptions_approved_cont;
                                    $scope.rejected = results.inscriptions_rejected_cont;
                                    $scope.pending = results.inscriptions_pending_cont;

                                });
                            });
                        } else {
                            $scope.inscription.put().then(function (result) {
                                $scope.gridOptionsInscriptionsForms.loadData(false);
                            })
                        }
                    }

                // END TODO 
                    
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });
            }
            $scope.confirmInscriptions = function (state) {

                var inscriptionIds = [];
                var duplicate = false;
                angular.forEach($scope.gridOptionsInscriptionsForms.gridApi.selection.getSelectedRows(), function (inscription) {
                    if (!inscription.duplicate) {
                        inscriptionIds.push(inscription.id);

                    } else {
                         duplicate = true;
                    }
                });

                var params = {
                    state: state,
                    inscriptionIds: inscriptionIds
                }

                if (inscriptionIds.length > 0) {
                    Restangular.all("inscriptions").customPOST({}, "change_states", params).then(function (results) {
                        if (results) {
                            if (state) {
                                toastr.success($filter('translate')('inscriptions_forms.inscription_approved'));
                            } else {
                                toastr.error($filter('translate')('inscriptions_forms.inscription_rejected'));
                            }
                            $scope.gridOptionsInscriptionsForms.gridApi.core.raise.itemChanged($scope)
                        }
                        //Obtenemos los contadores de pendientes, aprobados y rechazados
                        Restangular.all("InscriptionsForms").customGET("CustomGetContInscriptions", { id: $stateParams.inscription_form_id }).then(function (results) {
                            $scope.accepted = results.inscriptions_approved_cont;
                            $scope.rejected = results.inscriptions_rejected_cont;
                            $scope.pending = results.inscriptions_pending_cont;

                        });
                        // Mandamos mensaje de aviso recordando que no se pueden realizar acciones para duplicados
                        if (duplicate) {
                            toastr.error($filter('translate')('inscriptions_forms.duplicate_message'));
                        }
                    }, function (error) {
                        logService.error(error);
                        var errorMessage = "Error desconocido";
                        if (error.data?.ExceptionMessage != null) errorMessage = error.data.ExceptionMessage;
                        $scope.gridOptionsInscriptionsForms.loadData(false);
                        toastr.error(errorMessage);
                    });

                } else {
                    if (duplicate) {
                        toastr.error($filter('translate')('inscriptions_forms.duplicate_message'));
                    }
                }


            }
        }
        
        $scope.deleteDialog = function (id, event_name) {
            $scope.id = id;
            $scope.event_name = event_name;
            modalService.confirm({
                title: $filter('translate')('inscriptions_forms.button_delete'),
                message: $filter('translate')('inscriptions_forms.delete_message') + " " + $scope.event_name + "?",
                onAccept: function () {
                    Restangular.one('InscriptionsForms', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('inscriptions_forms.delete_success'));
                        $scope.gridOptionsInscriptionsForms.gridApi.core.raise.itemDeleted($scope);
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };                                
        $scope.capacityDetails = function (formId) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: CapacityDetailModalView,
                controller: "CapacityDetailsModalCtrl",
                size: 'lg',
                resolve: {
                    inscription_form_id: function () {
                        return formId
                    },
                }
            });
        }
        $scope.newInscription = function (inscription_form_id) {

            let $modalInstance = null;
            if (angular.isDefined(inscription_form_id)) {
                Restangular.one('InscriptionsForms', inscription_form_id).get().then(function (results) {
                    $scope.inscription_form = results;
                    if (!$rootScope.sizeLg) {
                        $modalInstance = $uibModal.open({
                            animation: true,
                            template: NewInscriptionModalView,
                            controller: "NewInscriptionModalCtrl",
                            resolve: {
                                inscription_form: function () {
                                    return $scope.inscription_form
                                }
                            }
                        });
                    } else {
                        $modalInstance = $uibModal.open({
                            animation: true,
                            template: NewInscriptionModalView,
                            controller: "NewInscriptionModalCtrl",
                            size: 'x-lg',
                            resolve: {
                                inscription_form: function () {
                                    return $scope.inscription_form
                                }
                            }
                        });
                    }
                   
                    $modalInstance.result.then(function (data) {

                        //if (data.success == false) {
                        //    $scope.loadGuests();

                        //} else {

                        var state = data.success;
                        logService.debug(data);

                        var params = {
                            state: state,
                            inscriptionIds: data.inscription
                        }
                        logService.debug(params);

                        Restangular.all("inscriptions").customPOST({}, "change_states", params).then(function (results) {
                            logService.debug(results);
                            if (results) {
                                if (angular.isDefined($scope.gridOptionsInscriptionsForms) && angular.isDefined($scope.gridOptionsInscriptionsForms.gridApi)) $scope.gridOptionsInscriptionsForms.gridApi.core.raise.itemChanged($scope)
                            }
                            //Obtenemos los contadores de pendientes, aprobados y rechazados
                            Restangular.all("InscriptionsForms").customGET("CustomGetContInscriptions", { id: inscription_form_id }).then(function (results) {
                                $scope.accepted = results.inscriptions_approved_cont;
                                $scope.rejected = results.inscriptions_rejected_cont;
                                $scope.pending = results.inscriptions_pending_cont;

                            });
                            $scope.loadGuests();
                        });

                        //}

                    }, function () {
                        console.info('Modal dismissed at: ' + new Date());
                        if (!$scope.$$phase) $scope.$apply();
                    });
                });
            } else {
                if ($rootScope.sizeLg) {
                    $modalInstance = $uibModal.open({
                        animation: true,
                        template: NewInscriptionModalView,
                        controller: "NewInscriptionModalCtrl",
                        size: 'x-lg',
                        resolve: {
                            inscription_form: function () {
                                return $scope.inscription_form
                            }
                        }
                    });
                } else {
                    $modalInstance = $uibModal.open({
                        animation: true,
                        template: NewInscriptionModalView,
                        controller: "NewInscriptionModalCtrl",
                        resolve: {
                            inscription_form: function () {
                                return $scope.inscription_form
                            }
                        }
                    });
                }
                
                $modalInstance.result.then(function (data) {
                    //if (data.success == false) {
                    //    $scope.loadGuests();
                    //} else {
                    var state = data.success;
                    var params = {
                        state: state,
                        inscriptionIds: data.inscription
                    }
                    Restangular.all("inscriptions").customPOST({}, "change_states", params).then(function (results) {
                        if (results) {
                            $scope.gridOptionsInscriptionsForms.gridApi.core.raise.itemChanged($scope)
                        }

                        //Obtenemos los contadores de pendientes, aprobados y rechazados
                        Restangular.all("InscriptionsForms").customGET("CustomGetContInscriptions", { id: $stateParams.inscription_form_id }).then(function (results) {
                            $scope.accepted = results.inscriptions_approved_cont;
                            $scope.rejected = results.inscriptions_rejected_cont;
                            $scope.pending = results.inscriptions_pending_cont;
                        });
                    }, function (error) {
                        logService.error(error);
                        var errorMessage = "Error desconocido";
                        if (error.data?.ExceptionMessage != null) errorMessage = error.data.ExceptionMessage;
                        toastr.error(errorMessage);
                    } );
                    //}

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });
            }

        };

        $scope.associate_tag = function (inscription) {            

            let $modalInstance = $uibModal.open({
                animation: true,
                template: AssignTagModalView,
                size: "md",
                controller: "AssignTagModalCtrl",
                resolve: {
                    event_guest: function () {
                        return inscription.event_guest;
                    }
                }
            });
            //Response del modal
            $modalInstance.result.then(function (data) {                
                Restangular.all("EventsGuests").customPOST({}, "CustomSaveIdentifier", data).then(function (results) {
                    if (results != true) {
                        modalService.confirm({
                            title: $filter('translate')('events.guests.warning'),
                            message: $filter('translate')('events.guests.identifier_already_used') + "?",
                            onAccept: function () {
                                data.forceSaved = true;
                                Restangular.all("EventsGuests").customPOST({}, "CustomSaveIdentifier", data).then(function (results) {
                                    toastr.success($filter('translate')('events.guests.identifier_saved'));                                    
                                    setTimeout(function () {
                                        $scope.gridOptionsInscriptionsForms.loadData(false);
                                    }, 500)
                                });

                            }
                        });
                    } else {
                        
                        $scope.gridOptionsInscriptionsForms.loadData(false);
                        if (!$scope.$$phase) $scope.$apply();
                    }
                });
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                if (!$scope.$$phase) $scope.$apply();
            });
        }

        $scope.export = function () {

         // Pillamos el tz local
            let localTimezoneOffset = moment.tz(moment.tz.guess()).format('Z');
            let localHourOffset = parseInt(localTimezoneOffset.split(":")[0], 10);
         // Construimos los parámetros de exportación
            let options = {
                filters: {  
                    EXPORT_TYPE: "INSCRIPTION",
                    LOCAL_HOUR_OFFSET: localHourOffset,
                    INSCRIPTION_FORM_ID: $stateParams.inscription_form_id,
                    EVENT_ID: $stateParams.id
                }
            };

            datasetsService.exportByType("inscriptions", options);

        };

        $scope.exportInscriptions = function (id) {
            window.open((window as any).CONFIG.api_url + "/inscriptions/export/csv?inscription_form_id=" + id);
            return;
        };


        $scope.filterInscriptions = function (filterForm) {

            /*logService.debug(filterForm);
            var filters = [];

            $('#' + filterForm).find('input').each(function (idx, input) {
                // Do your DOM manipulation here
                filter = {
                    id: $(input).attr('id'),
                    value: $(input).val()
                }

                filterJson = JSON.stringify(filter);
                filters.push(filterJson);
            });
            options = $scope.options;
            options.filters = filters;

            Restangular.all("Inscriptions").getList(options).then(function (inscriptions_fields) {                                                       
                logService.debug(inscriptions_fields);
            
            });
                                                        
            logService.debug(filters);*/
        }

        $scope.printDialog = function (code, type_document, type_result, id) {
            let params = {
                entity_type: "inscriptions_forms",
                entity_type_id: $stateParams.inscription_form_id,
                documents: { codes: [code] }
            };
            generateDocumentService.documentNew({
                params: params,
                onAccept: function (data) {
                    angular.forEach(data, function (item) {
                        $http({
                            method: 'post',
                            url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                            params: { document_id: item.document_id, outputType: 'pdf', inscription_form_id: params.entity_type_id }
                        }).then(function (result, status, headers, config) {
                            let url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                            window.open(url, '_blank');
                        });
                    })
                }
            });
        };
        
    }])

.controller("ShowInscriptionModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'inscription','inscription_form_id', function ($scope, $uibModalInstance, Restangular, modalService, $filter, inscription, inscription_form_id) {

    $scope.inscription = inscription;

    Restangular.all("InscriptionsForms").customGET("ShowInscription", { inscription_id: inscription.id, inscription_form_id: inscription_form_id }).then(function (results) {        
        $scope.inscription_form_fields = results
    });

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.downloadFile = function (field) {
        modalService.confirm({
            title: $filter('translate')('inscriptions_forms.download_file'),
            message: $filter('translate')('inscriptions_forms.download_file_message') + field.value + "?",
            onAccept: function () {
                    var url = (window as any).CONFIG.api_url + field.path + "/force";
                    window.open(url, '_blank');
            }
        });
    };

    $scope.previewImage = function (field) {
        var url = (window as any).CONFIG.api_url + field.path;
        window.open(url, '_blank');
    };

    $scope.confirmInscription = function (state) {
        // Devolvemos el control al principal        
        $scope.inscription.state = state;
        $uibModalInstance.close({ inscription: $scope.inscription});
    };

    $scope.deleteInscription = function () {
        modalService.confirm({
            title: $filter('translate')('inscriptions_forms.button_delete'),
            message: $filter('translate')('inscriptions_forms.delete_message') + "?",
            onAccept: function () {
                Restangular.one('InscriptionsForms/DeleteInscription', $scope.inscription.id).remove().then(function () {
                    toastr.success($filter('translate')('inscriptions_forms.deleted_success'));
                    //$uibModalInstance.dismiss('cancel');
                    $scope.inscription.is_deleted = true;
                    $uibModalInstance.close({ inscription: $scope.inscription });
                });
            }
        });
    };

}])
    .controller("EditInscriptionModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'inscription', 'inscription_form_id', '$uibModal', 'logService',
        function ($scope, $uibModalInstance, Restangular, modalService, $filter, inscription, inscription_form_id, $uibModal, logService) {

        logService.debug("EditInscriptionModalCtrl entered")

        // TODO
        $scope.inscription = inscription;

        // Sacamos todos los campos que debería tener
        Restangular.one('Inscriptions', inscription.id).get().then(function (result) {
            $scope.inscription = result;
            Restangular.one('InscriptionsForms', inscription_form_id).get().then(function (results) {

                $scope.inscription_form = results

                let inscription_form_fields = $scope.inscription_form.FK_inscriptions_forms_fields_inscriptions_forms

                // Comprobamos si ese campo está ya en la inscripción, si no es así lo añadimos.
                let filledInscriptionFormFieldsIds = $scope.inscription.FK_inscriptions_fields_inscriptions.map(f => f.inscription_form_field_id);

                inscription_form_fields.forEach(function (form_field) {

                    if (!filledInscriptionFormFieldsIds.includes(form_field.id)) {

                        let new_inscription_field = {
                            inscription_form_field_id: form_field.id,
                            inscription_id: inscription.id,
                            value: "",
                            FK_inscriptions_fields_inscriptions_forms_fields: form_field
                        }

                        logService.debug('new_inscription_field')
                        logService.debug(new_inscription_field)

                        $scope.inscription.FK_inscriptions_fields_inscriptions.push(new_inscription_field);

                    }
                })

                setUpInscriptionsFields();
                // Fin 
            });
        });

        // Para hacer que funcionen los select, hay que pasar el value de string a int

        let setUpInscriptionsFields = function () {

            $scope.inscription.FK_inscriptions_fields_inscriptions.forEach(function (f) {

                if (f.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_types_fields.code == 'select' ||
                    f.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_types_fields.code == 'radio-horizontal' ||
                    f.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_types_fields.code == 'radio-vertical') f.value = parseInt(f.value);

                else if (f.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_types_fields.code == 'checkbox-horizontal' ||
                    f.FK_inscriptions_fields_inscriptions_forms_fields.FK_inscriptions_forms_fields_types_fields.code == 'checkbox-vertical') {

                    if (f.value != null && f.value != "") {
                        f.valuesArray = f.value.split(',').map(m => parseInt(m));
                    }
                    else {
                        f.valuesArray = [];
                    }
                }

                // Para campos descendientes

                if (f.FK_inscriptions_fields_inscriptions_forms_fields.parent_field_id != null) {
                    f.parentField = $scope.inscription.FK_inscriptions_fields_inscriptions.filter(m => m.FK_inscriptions_fields_inscriptions_forms_fields.id == f.FK_inscriptions_fields_inscriptions_forms_fields.parent_field_id).pop();
                    logService.debug("f condicional")
                    logService.debug(f)
                }
            })

            $scope.inscription.FK_inscriptions_fields_inscriptions = $scope.inscription.FK_inscriptions_fields_inscriptions.sort(function (a, b) { return a.FK_inscriptions_fields_inscriptions_forms_fields.order - b.FK_inscriptions_fields_inscriptions_forms_fields.order }); // Los ordenamos tal y como salen en la inscripción

        }

        $scope.changeValuesArray = function (field, option) {

            let index = field.valuesArray.indexOf(option.id);

            if (index < 0) {
                field.valuesArray.push(option.id);
            } else {
                field.valuesArray.splice(index, 1);
            }
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.previewImage = function (relatedFile) {

            var url = (window as any).CONFIG.api_url + relatedFile.path;
            window.open(url, '_blank');

        };

        $scope.downloadFile = function (relatedFile) {
            modalService.confirm({
                title: $filter('translate')('inscriptions_forms.download_file'),
                message: $filter('translate')('inscriptions_forms.download_file_message') + relatedFile.filename + "?",
                onAccept: function () {
                    var url = (window as any).CONFIG.api_url + relatedFile.path + "/force";
                    window.open(url, '_blank');
                }
            });
        }

        $scope.confirmInscription = function (state) {
            // Devolvemos el control al principal
            $scope.inscription.state = state;
            $uibModalInstance.close({ inscription: $scope.inscription });
        };

        $scope.deleteInscription = function () {
            modalService.confirm({
                title: $filter('translate')('inscriptions_forms.button_delete'),
                message: $filter('translate')('inscriptions_forms.delete_message') + "?",
                onAccept: function () {
                    Restangular.one('InscriptionsForms/DeleteInscription', $scope.inscription.id).remove().then(function () {

                        toastr.success($filter('translate')('inscriptions_forms.deleted_success'));

                        //$uibModalInstance.dismiss('cancel');
                        $scope.inscription.is_deleted = true;
                        $uibModalInstance.close({ inscription: $scope.inscription });

                    });
                }
            });
        };

        $scope.modifyInscription = function () {

            $scope.inscription.FK_inscriptions_fields_inscriptions.forEach(function (f) {
                // Campos de opciones múltiples
                if (f.valuesArray) {
                    f.value = f.valuesArray.toString();
                }
                // Campos condicionales
                if (f.parentField) {
                    if (!(f.parentField.value == f.FK_inscriptions_fields_inscriptions_forms_fields.parent_option_id
                        || (f.parentField.valuesArray && f.parentField.valuesArray.includes(f.FK_inscriptions_fields_inscriptions_forms_fields.parent_option_id)))) {
                        f.value = null;
                    }

                }
            });

            // Campos condicionales cuya condición ha cambiado
            Restangular.all("Inscriptions/ModifyInscription").customPOST($scope.inscription).then(function (results) {
                if (results) {
                    toastr.success($filter('translate')('inscriptions_forms.modify_success'));
                }
                $uibModalInstance.dismiss('cancel');
            });
        };

}])
.controller("CapacityDetailsModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'inscription_form_id','$http', function ($scope, $uibModalInstance, Restangular, modalService, $filter, inscription_form_id, $http) {
        
    $scope.fields = [];

    Restangular.all("InscriptionsForms").customGET("CapacityDetail", { inscription_form_id: inscription_form_id }).then(function (results) {
        $scope.fields = results;
    });

    $scope.saveCapacities = function () {

        var capacitiesDetail = [];
        angular.forEach($scope.fields, function (item) {
            capacitiesDetail.push(item);
        });

        var params = {            
            capacitiesDetail: JSON.stringify($scope.fields)
        }

        var data_encoded = JSON.stringify(params);

        Restangular.all("InscriptionsForms").customPOST($scope.fields, "CapacityDetailSave", {}).then(function (results) {
            if (results) {                
                    toastr.success($filter('translate')('inscriptions_forms.capacity_updated'));
            }
            $uibModalInstance.dismiss('cancel');
        });
    }    
    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    
}])

.controller("NewInscriptionModalCtrl", ['$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', 'inscription_form', 'logService',
    function ($scope, $uibModalInstance, Restangular, modalService, $filter, inscription_form, logService) {
            
    $scope.inscription_form = inscription_form;
    $scope.inscription = {};
    $scope.checkSavedTimeout = null;
    var urlPublic = "";
    Restangular.all("InscriptionsForms").customGET("CustomGetExternalUrl").then(function (url) {
        urlPublic = url;
    });

    setTimeout(function () {
        $("#ifForm").attr("src", urlPublic + "/Inscriptions/Index/" + inscription_form.uid + "?admin=1");
    }, 1000);

    $scope.onCancel = function () {
        clearTimeout($scope.checkSavedTimeout);
        $uibModalInstance.close({ inscription: null, success: false }); //asi refresca el listado
        //$uibModalInstance.dismiss('cancel');
    };

    $scope.checkFormCompleted = function () {
        var okField = $("#ifForm").contents().find("#inscription_completed_id");

        if (okField.length) {     
            var id = okField.val();
            logService.debug(id);
            $uibModalInstance.close({ inscription: id, success: true });                        

        } else {
            $scope.checkSavedTimeout = setTimeout(function () {
                $scope.checkFormCompleted();
            }, 1000);
        }
    };

    $scope.saveInscription = function () {
        clearTimeout($scope.checkSavedTimeout);
        logService.debug("entra en saveInscription, apartir de aqui no funciona porque no puede acceder a otro dominio...");
        //$("#ifForm").contents().find("#btnInscriptionSend").trigger('click');
        $("#formInscription #btnInscriptionSend").click();

        //$scope.checkFormCompleted();
    };

}])

.controller("AssignTagModalCtrl", ['$scope', '$uibModalInstance', 'event_guest', 'Restangular', '$http', 'modalService', '$filter', function ($scope, $uibModalInstance, event_guest, Restangular, $http, modalService, $filter) {
    //Comprobamos si tiene permiso escritura

    $scope.event_guest = event_guest;    
    if ($scope.event_guest.identify_id != null) {
        Restangular.one('Identifiers', $scope.event_guest.identify_id).get().then(function (results) {            
            $scope.event_guest.identifier = results.value            
        });
    }
    
    //if (event_guest.FK_events_guests_identifiers != null) $scope.event_guest.identifier = event_guest.FK_events_guests_identifiers.value;
    //$scope.event_guest.identifier = "";

    Restangular.all("IdentifiersTypes").getList().then(function (identifiers_types) {
        $scope.identifiers_types = identifiers_types;
        $scope.event_guest.identifier_type = identifiers_types[0];
    });

    $scope.keyPressed = function (keyEvent) {
        if (keyEvent.which === 13)
            $scope.saveIdentifier($scope.event_guest.identifier);
    }

    $scope.saveIdentifier = function (identifier) {

        var data = {
            value: identifier,
            identifier_type_id: $scope.event_guest.identifier_type.id,
            forceSaved: false,
            person_id: $scope.event_guest.person_id,
            event_id: $scope.event_guest.event_id
        }        

        $uibModalInstance.close(data);

    };

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

}]);